export default {"src":"/_next/static/media/home-office-perks.ee7da5e6.svg","height":200,"width":270,"blurWidth":0,"blurHeight":0};